import { useState } from "react"
import { useWallets, WalletBackup } from "@/api/wallets"
import Loader from "@/components/layout/loader"
import { usePortal, useWalletBackup } from "@/state/stores/wallet.store"
import { Button } from "@/components/ui/button"
import { Input } from "@/components/ui/input"
import ButtonCopy from "@/components/ui/button-copy"

export function WalletEject() {
  const [step, setStep] = useState<"form" | "ejecting" | "done">("form")
  const portal = usePortal()
  const { backupMethod, backupConfigs } = useWalletBackup()
  const { wallet } = useWallets()
  const [privateKey, setPrivateKey] = useState<string | null>(null)

  if (!portal || !wallet) return null

  const eject = async () => {
    setStep("ejecting")
    const walletBackup = wallet.walletBackups.find(
      (backup: WalletBackup) => backup.method === `${backupMethod}-SECP256K1`,
    )

    if (!walletBackup) {
      throw new Error("Backup not found")
    }

    portal.onReady(async () => {
      const privateKey = await portal.eject(
        walletBackup.cipherText,
        backupMethod!,
        backupConfigs!,
        walletBackup.share,
      )
      setPrivateKey(privateKey.SECP256K1)
      setStep("done")
    })
  }

  if (step === "form") {
    return (
      <div className="flex flex-col items-start space-y-4">
        <p className="text-sm">Export your wallet private key:</p>
        <Button onClick={eject} className="w-full" data-testid="export-wallet">
          Export Wallet Private Key
        </Button>
      </div>
    )
  } else if (step === "ejecting") {
    return <Loader message="Exporting wallet..." />
  } else if (step === "done") {
    return (
      <div className="flex flex-col items-stretch space-y-4">
        <p className="text-sm">Here's your wallet's private key:</p>
        <Input
          data-testid="private-key"
          readOnly
          value={privateKey!}
          rightIcon={<ButtonCopy value={privateKey!} />}
        />
      </div>
    )
  }
}
